import utilsArray from './array.js'
const _toString = Object.prototype.toString
// 类型检查  by shw
const toRawType = function (value) {
	return _toString.call(value).slice(8, -1)
}
// 判断空对象 by shw
const isEmptyObj = function (obj) {
	if (toRawType(obj) !== 'Object') {
		console.warn('this is not a object')
	}
	return Object.keys(obj).length === 0
}
// JSON解析 by shw
const JSONparse = function (jsonStr, type) {
	try {
		const obj = JSON.parse(jsonStr)
		if (type === 'object' && typeof obj !== 'object') {
			return {}
		}
		return obj
	} catch (error) {
		console.log(error)
		if (type === 'object') {
			return {}
		}
		return undefined
	}
}
// 深拷贝 by shw
const JSONcopy = function (obj) {
	return JSON.parse(JSON.stringify(obj))
}
// 深拷贝 by shw
const deepClone = function (target) {
	let result
	if (toRawType(target) === 'Object') {
		result = {}
		for (const i in target) {
			if (Object.prototype.hasOwnProperty.call(target, i)) {
				result[i] = deepClone(target[i])
			}
		}
	} else if (toRawType(target) === 'Array') {
		result = []
		target.forEach(item => {
			result.push(deepClone(item))
		})
	} else {
		result = target
	}
	return result
}
// 判断undefined/null by shw
const isDef = function (value) {
	return value !== undefined && value !== null
}
// 隐式类型转换比较-number|string by shw
const compareStrNum = function (val, compVal) {
	if (typeof compVal !== 'string' && typeof compVal !== 'number') {
		return false
	}
	return val === (compVal - 0) || val === (compVal + '')
}
// obj转化str by shw
const obj2str = function (obj) {
	let description = ''
	for (var i in obj) {
		var property = obj[i]
		description += i + ' = ' + property + '\n'
	}
	return description
}
// 判断两个数据完全相等 by shw
const compare = function (origin, target, log = false) {
	if (typeof target !== 'object' || target === null) {
		const val = origin === target
		if (log && !val) {
			console.log(`valpre:${origin},valcur:${target}`)
		}
		return val
	}
	if (typeof origin !== 'object') {
		if (log) {
			console.log('origin类型错误')
		}
		return false
	}
	if (Object.keys(origin).length !== Object.keys(target).length) {
		if (log) {
			const originKeys = Object.keys(origin)
			const targetKeys = Object.keys(target)
			const originKeysDiff = originKeys.filter(item => {
				return !~targetKeys.indexOf(item)
			})
			const targetKeysDiff = targetKeys.filter(item => {
				return !~originKeys.indexOf(item)
			})
			const keys = utilsArray.arrDedup([...originKeysDiff, ...targetKeysDiff])
			console.log(`key数量不等,keys:${keys.join(',')}`)
		}
		return false
	}
	for (const key of Object.keys(target)) {
		if (!compare(origin[key], target[key])) {
			if (log) {
				console.log(`key:${key},valpre:`, origin[key], ' ,valcur:', target[key])
			}
			return false
		}
	}
	return true
}
// 比较两个数组的数据, 返回 增加的, 删除的, 以及 改变的
const compareDiff = function (pre, cur) {
	const data = {}
	if (pre.length > cur.length) {
		const count = pre.length - cur.length
		data.delete = pre.slice(pre.length - count)
		if (cur.length !== 0) {
			const update = []
			cur.forEach((item, index) => {
				if (!compare(item, pre[index])) {
					update.push([pre[index], item])
				}
			})
			if (update.length > 0) {
				data.update = update
			}
		}
	} else if (pre.length < cur.length) {
		const count = cur.length - pre.length
		data.add = cur.slice(cur.length - count)
		if (pre.length !== 0) {
			const update = []
			pre.forEach((item, index) => {
				if (!compare(item, cur[index])) {
					update.push([item, cur[index]])
				}
			})
			if (update.length > 0) {
				data.update = update
			}
		}
	} else {
		if (pre.length !== 0) {
			const update = []
			pre.forEach((item, index) => {
				if (!compare(item, cur[index])) {
					update.push([item, cur[index]])
				}
			})
			if (update.length > 0) {
				data.update = update
			}
		}
	}
	return data
}
// 数组转对象
const fromEntries = function (arr) {
	const obj = {}
	arr.forEach(item => {
		obj[item[0]] = item[1]
	})
	return obj
}
// 获取深层属性
const getObjDeepValue = function (obj, prop) {
	if (~prop.indexOf('.')) {
		return prop.split('.').reduce((pre, cur) => {
			return !isDef(pre) ? '' : pre[cur]
		}, obj)
	}
	return isDef(obj[prop]) ? obj[prop] : ''
}

// 数组比较工具
class CompareArrayUtils {
	constructor () {
		this.compareData = {}
	}

	setData (arr, fn) {
		const arrObj = {}
		arr.forEach(item => {
			const key = typeof fn === 'function' ? fn(item) : item
			arrObj[key] = true
		})
		this.compareData = Object.freeze(arrObj)
	}

	has (val) {
		return this.compareData[val]
	}
}

const compareArrayUtils = function () {
	return new CompareArrayUtils()
}
export default {
	toRawType,
	isEmptyObj,
	JSONparse,
	JSONcopy,
	deepClone,
	isDef,
	compareStrNum,
	obj2str,
	compare,
	compareDiff,
	fromEntries,
	getObjDeepValue,
	compareArrayUtils
}



// WEBPACK FOOTER //
// ./src/lib/util/src/type.js